import FinanceNav from "../../pages/Dashboard/Finance/FinanceNav";
import FinanceIndex from "../../pages/Dashboard/Finance/FinanceIndex";
import PatientsInFinance from "../../pages/Dashboard/Finance/Patients/Patients";
import ManageExpensesType from "../../pages/Dashboard/Finance/expensesType/ManageExpensesType";
import ListExpenseSource from "../../pages/Dashboard/Finance/ExpenseSource/ListExpenseSource/ListExpenseSource";
import AddExpenseSource from "../../pages/Dashboard/Finance/ExpenseSource/AddExpenseSource/AddExpenseSource";
import ExpensesList from "../../pages/Dashboard/Finance/Expenses/ExpensesList";
import Expenses from "../../pages/Dashboard/Finance/Expenses/Expenses";
import ApprovePurchase from "../../pages/Dashboard/Finance/ApprovePurchase/ApprovePurchase";
import Payroll from "../../pages/Dashboard/Finance/Payroll/Payroll";
import Advance from "../../pages/Dashboard/Finance/Advance/Advance";
import Bonus from "../../pages/Dashboard/Finance/Bonus/Bonus";
import Report from "../../pages/Dashboard/Finance/Report/Report";
import MedicinePayment from "../../pages/Dashboard/Finance/MedicinePayment/MedicinePayment";
import MedicinePaymentList from "../../pages/Dashboard/Finance/MedicinePayment/MedicinePaymentList";
import ExpensePaymentList from "../../pages/Dashboard/Finance/ExpensePayment/ExpensePaymentList";
import ExpensePayment from "../../pages/Dashboard/Finance/ExpensePayment/ExpensePayment";

const financeRoutes = {
  path: "/finance",
  element: <FinanceNav />,
  children: [
    { path: "/finance", element: <FinanceIndex /> },
    { path: "/finance/patients", element: <PatientsInFinance /> },
    { path: "/finance/expenses-type", element: <ManageExpensesType /> },
    { path: "/finance/expense-source", element: <ListExpenseSource /> },
    { path: "/finance/expense-source/add", element: <AddExpenseSource /> },
    { path: "/finance/expenses", element: <ExpensesList /> },
    { path: "/finance/expenses/add", element: <Expenses /> },
    { path: "/finance/expense-payments/", element: <ExpensePaymentList /> },
    { path: "/finance/expense-payments/add", element: <ExpensePayment /> },
    { path: "/finance/payroll", element: <Payroll /> },
    { path: "/finance/advance", element: <Advance /> },
    { path: "/finance/bonus", element: <Bonus /> },
    { path: "/finance/approve", element: <ApprovePurchase /> },
    { path: "/finance/medicine-payment/", element: <MedicinePaymentList /> },
    { path: "/finance/medicine-payment/add", element: <MedicinePayment /> },
    { path: "/finance/report", element: <Report /> },
  ],
};

export default financeRoutes;
